import React, { useEffect, useRef, MutableRefObject } from 'react';
import { Message as MessageType } from './types';
import Message from './Message';
import { MessagesContainer, LoadingIndicator } from './styles';

interface ChatMessagesProps {
  messages: MessageType[];
  isLoading: boolean;
  isDarkMode: boolean;
  audioCacheRef: MutableRefObject<Map<string, string>>;
  autoPlayTargetId: string | null;
  onAutoPlayDone: () => void;
}

const ChatMessages: React.FC<ChatMessagesProps> = ({
  messages,
  isLoading,
  isDarkMode,
  audioCacheRef,
  autoPlayTargetId,
  onAutoPlayDone,
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  // Index of first non-error assistant message — shows disclosure there
  const firstVoiceIdx = messages.findIndex(
    m => m.role === 'assistant' && !m.isError
  );

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isLoading]);

  return (
    <MessagesContainer isDarkMode={isDarkMode}>
      {messages.map((message, index) => (
        <Message
          key={message.id}
          message={message}
          isDarkMode={isDarkMode}
          audioCacheRef={audioCacheRef}
          autoPlay={message.id === autoPlayTargetId}
          showDisclosure={index === firstVoiceIdx}
          onAutoPlayDone={onAutoPlayDone}
        />
      ))}
      {isLoading && (
        <LoadingIndicator>
          <span></span>
          <span></span>
          <span></span>
        </LoadingIndicator>
      )}
      <div ref={messagesEndRef} />
    </MessagesContainer>
  );
};

export default ChatMessages;
